import { createContext } from "react";

import type { AgenticAiContextType } from "./types";

export const initialAgenticAiContext: AgenticAiContextType = {
  openChat: () => {},
  closeChat: () => {},
  toggleOpenChat: () => {},
  newSession: () => {},
  sendUserPrompt: () => {},
  registerContext: () => () => {},
  registerAttachedFiles: () => () => {},
  registerTool: () => () => {},
  registerSkill: () => () => {},
  registerLiquidField: () => {},
  unregisterLiquidField: () => {},
};

export const AgenticAiContext = createContext<AgenticAiContextType>(initialAgenticAiContext);
